(function ReservationsBydate($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Reports/reservationsByDate', function onload()
		{
			var _lookupVendor,
			    _selectVendor,
			    _resetVendor,
			    component_type = $('#reportreservationsbydate-component').val();

			$('#reportreservationsbydate-component').change(function componentTypeChange(e) {
				component_type = $(this).val();

				_lookupVendor(component_type);

				_resetVendor();
			});

			$('.reset-vendor').click(function resetClicked(e) {
				e.preventDefault();

				_resetVendor();
			});

			_lookupVendor = function _lookupVendor(component_type)
			{
				Adzuki.Typeahead(
					'#reportreservationsbydate-vendor_search',
					'/Vendors/searchVendorByType/' + component_type + '/',
					function select(item, $self, typeahead) {
						_selectVendor(item);
					},
					null,
					null,
					null,
					true
				);
			};

			_selectVendor = function _selectVendor(vendor)
			{
				$('#reportreservationsbydate-vendor_id').val(vendor.id);
				$('#reportreservationsbydate-vendor_search').prop('disabled', true);

				$('.reset-vendor').removeClass('hidden');
			};

			_resetVendor = function _resetVendor()
			{
				$('#reportreservationsbydate-vendor_id').val('');
				$('#reportreservationsbydate-vendor_search').val('');
				$('#reportreservationsbydate-vendor_search').prop('disabled', false);

				$('.reset-vendor').addClass('hidden');
			};

			_lookupVendor(component_type);
		});
	});
}(jQuery, window.Adzuki || {}));
